import { MemberType, Title } from "../../Enums/PersonEnums";
import IGeneralFields from "./IGeneralFileds";

export type TitleType = keyof typeof Title;
export const memberTypeOptions = [
  { id: '0', name: 'Member' }, 
  { id: '1', name: 'Nonmeber' }, 
  { id: '2', name: 'Staff' }
];

export type IPerson = IGeneralFields &
  PersonRelationsProps &
  PersonDataProps &
  PersonSocialProps &
  PersonOfficeProps &
  PersonBioProps &
  PersonAOPProps &
  PersonProfessionalCareerProps &
  PersonUserProps & {
    idProviders?: IDProvidersProps;
  } & Preferences
  & IViewedMessages;

export type PersonRelationsProps = {
  memberType: MemberType;
  firm: string;
  firmName?: string;
  externalType: string;
  submittedBy: string;
  generatedId: Number;
  legacyId?: string;
}

export type PersonDataProps = {
  photo: string,
  name: string,
  middleInitial: string,
  lastName: string,
  suffix: string,
  honorary: string,
  title: TitleType | undefined,
  unlistedTitle: string,
  unlistedTitleToggle: boolean,
  listTitle: string,
  listingCategory: string,
  countryCodePhoneNumber: string,
  phoneNumber: string,
  phoneBaseCode: string,
  directCountryCodePhoneNumber: string,
  directPhoneNumber: string,
  directPhoneBaseCode: string,
  displayName: string,
  isSearchable: boolean,
  isWsgMember?: boolean,
  isAttorney: boolean,
  hasAssistant: boolean,
  assistantName: string,
  assistantEmail: string,
  firmEmail: string,
  mainOffice: string,
  mainOfficeName?: string,
  AOPRankingNames?: string,
  multipleOffices?: boolean,
  profileURL: string,
  isOnlySocials?: boolean;
  isOnlyAops?: boolean;
  isOnlyProfessionalCareer?: boolean;
  firmAdminAccess?: boolean;
  firmLegacyId?: string;
  firmLogo?: string;
  mainContact: boolean;
  
}

export type PersonProfessionalCareerProps = {
  significantAccomplishments?: string
  industryOrganizationAffiliation?: string[]
  additionalAffiliations?: string[]
  professionalActivitiesAndPreviousExperience?: string
  additionalActivities?: string
  pastEmploymentPositions?: string
  seminarPresentation?: string
  additionalInformation?: string
  publications?: string
}

export type TwoFactorAuthenticationProps = {
  status: boolean;
  updatedAt: string;
}

export type PersonUserProps = {
  userId?: string;
  role?: string;
  twoFactorAuthentication?: TwoFactorAuthenticationProps | null;
}

export type PersonBioProps = {
  bio: string;
  languages: string[];
  barAdmissions: string[];
  education?: string;
  yearJoinedFirm?: number;
}

export type PersonOfficeProps = {
  additionalOffices: string[]
}

export type PersonSocialProps = {
  socialNetworks: { name: string, url: string }[]
}

export type PersonAreasOfPracticeProps = {
  id: string,
  name: string,
  expertise: boolean,
  practiceChair: boolean,
  order: number
  isTargeted?: boolean;
  isMapped?: boolean;
  isIgnored?: boolean;
  firms?: any;
}

export type PersonAOPProps = {
  areasOfPractice: PersonAreasOfPracticeProps[] | string[];
  aopExpertiseIds?: string[];
  aopRankName1?: string;
  aopRankName2?: string;
  aopRankName3?: string;
  aopRankName4?: string;
  myAOP?: string[];
  aopRankingIds?: string[];
  practiceChair?: boolean;
};

export type PersonCatalogsProps = {
  visibles: number[];
  mode: string;
  authenticationType?: string;
  disabledFirm?: boolean;
}

export type IDProvidersProps = {
  googleAccountId?: string;
  linkedinAccountId?: string;
  wechatAccountId?: string;
}


type Preferences = {
  preferences?: IPreferences
}
interface IPreferences {
  myWSGOrderCards?: Array<number>;
  myWSGDismissedInviteGroupIds?: string[];
}
interface IViewedMessages {
  viewedMessages?: IViewedMessage[];
}

export interface IViewedMessage {
  messageId: string;
  messageTpye: string;
}

export interface User {
  Id: string;
  Name: string;
  Email: string;
  // ... other properties
}

export interface Firm {
  id: string;
  name: string;
}
export interface DataItem {
  id: string;
  title?: string;
  name?: string;
  middleName?: string
  lastName?: string
  membership?: string;
  honorary?: string;
  suffix?: string;
  photo?: string;
  userId?: string | null;
  contact?: string;
  phoneNumber?: string | null;
  isSearchable?: boolean;
  isAttorney?: boolean;
  facebook?: string;
  instagram?: string;
  x?: string;
  linkedIn?: string;
  otherSocialMedia?: string | null;
  profileUrl?: string | null;
  otherTitleFlag?: boolean;
  otherTitle?: string | null;
  listingCategory?: string | null;
  bio?: string | null;
  assistantFlag?: boolean;
  assistantName?: string | null;
  assistantEmail?: string | null;
  whatsappUrl?: string | null;
  wechatUrl?: string | null;
  significantAccomplishments?: string | null;
  industryOrganizationAffiliation?: string | null;
  professionalActivitiesAndPreviousExperience?: string | null;
  seminarPresentation?: string | null;
  additionalInformation?: string | null;
  firmId?: string | null;
  userName: string;
  createdAt: string;
  generatedId: string;
  displayName: string,
}

export type personErrorsType = {
  firm: { error: boolean, message: string },
  name: { error: boolean, message: string },
  lastName: { error: boolean, message: string },
  title: { error: boolean, message: string },
  listTitle: { error: boolean, message: string },
  listingCategory: { error: boolean, message: string },
  assistantName: { error: boolean, message: string },
  assistantEmail: { error: boolean, message: string },
  aop: { error: boolean, message: string },
  mainOffice: { error: boolean, message: string },
  firmEmail: { error: boolean, message: string },
  bio: { error: boolean, message: string },
  significantAccomplishments: { error: boolean, message: string };
  industryOrganizationAffiliation: { error: boolean, message: string };
  additionalActivities: { error: boolean, message: string };
  seminarPresentation: { error: boolean, message: string };
  additionalInformation: { error: boolean, message: string };
  externalType: { error: boolean, message: string };
}